import { render, staticRenderFns } from "./index1 copy.vue?vue&type=template&id=51b8ed60&scoped=true"
import script from "./index1 copy.vue?vue&type=script&lang=js"
export * from "./index1 copy.vue?vue&type=script&lang=js"
import style0 from "./index1 copy.vue?vue&type=style&index=0&id=51b8ed60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b8ed60",
  null
  
)

export default component.exports